"use client";

import React from "react";
import CustomerDetails from "../../../global/view/customer-detailsForm"; 

export default function CustomerDetailsScript() {
  return <CustomerDetails backTo="/customer/dispensary/script" />;
}
